var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ape-container",style:({backgroundImage: 'url('+this.mxDomain.backgroundImg+')'})},[_c('router-view'),_c('Footer',{attrs:{"tag":_vm.tag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }